const emailValidation = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ipv4Validation = (ip) =>
  /^((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/.test(ip);

const portValidation = (port) => /^[1-9]\d{0,4}$/.test(port);

const vatValidation = (vat) => {
  if (vat === "" || vat == null) return true;
  if (!/^(\d+([.,]\d{0,2})?)?$/.test(vat)) return false;
  const normalizedVat = Number(vat.toString().replace(",", "."));
  return normalizedVat >= 0 && normalizedVat <= 100;
};

const priceValidation = (price) => /^-?(\d+([.,]\d{0,2})?)?$/.test(price);

const normalizeOptionalNumber = (value) =>
  !value && value !== 0 ? null : Number(value.toString().replace(",", "."));

export {
  emailValidation,
  ipv4Validation,
  portValidation,
  vatValidation,
  priceValidation,
  normalizeOptionalNumber,
};
